module.exports = __webpack_public_path__ + "img/gp_main01_phone.759006bf.png";